jQuery(function () {
    var $slides = $(".hero-slide");
    var currentSlide = 0;

    TweenLite.set($slides.filter(":gt(0)"), { autoAlpha: 0, transform: 'scale3d(1.2,1.2,1.2)' });
    TweenLite.delayedCall(4, nextSlide);

    function nextSlide() {
        var tl = new TimelineLite();
        TweenLite.to($slides.eq(currentSlide), 2, { autoAlpha: 0, delay: 2 });

        currentSlide = ++currentSlide % $slides.length;

        tl.fromTo(
            $slides.eq(currentSlide),
            2,
            { autoAlpha: 0 },
            { autoAlpha: 1, ease: 'linear' },
            "go"
        )
        .fromTo(
            $slides.eq(currentSlide),
            12,
            { transform: 'scale3d(1.2,1.2,1.2) translate3d(0,0,0)' },
            { transform: "scale3d(1.5,1.5,1.5) translate3d(-10vw, 5vh, 0)", ease: 'linear' },
            "go"
        );
        TweenLite.delayedCall(10, nextSlide);
    }
});
